import { Pagination } from '@carbon/react';
import { useTranslation } from 'react-i18next';
import { cx } from '../../utils';
import styles from './CdPaginationBar.module.scss';

export interface CdPaginationBarProps {
  page: number;
  pageSize: number;
  totalItems: number;
  pageSizes?: number[];
  onChange: (next: { page: number; pageSize: number }) => void;
  className?: string;
}

/** Table footer pagination ("Items per page · 1–100 of 100 items · 1 of 10 pages ◀ ▶"). */
export const CdPaginationBar = ({
  page,
  pageSize,
  totalItems,
  pageSizes = [10, 25, 50, 100],
  onChange,
  className,
}: CdPaginationBarProps) => {
  const { t } = useTranslation('common');

  return (
    <Pagination
      className={cx(styles.pagination, className)}
      page={page}
      pageSize={pageSize}
      pageSizes={pageSizes}
      totalItems={totalItems}
      backwardText={t('pagination.previousPage')}
      forwardText={t('pagination.nextPage')}
      itemsPerPageText={t('pagination.itemsPerPage')}
      itemRangeText={(min, max, total) => t('pagination.itemRange', { min, max, total })}
      itemText={(min, max) => t('pagination.itemText', { min, max })}
      pageRangeText={(_current, total) => t('pagination.pageRange', { count: total, total })}
      pageSelectLabelText={(total) => t('pagination.pageSelectLabel', { count: total, total })}
      pageText={(pageNumber) => t('pagination.pageText', { page: pageNumber })}
      onChange={({ page: nextPage, pageSize: nextSize }) =>
        onChange({ page: nextPage, pageSize: nextSize })
      }
    />
  );
};
